"use strict";
/**************************************************************************************************
 *
 *       @file ./vaccine.ts
 *
 *       Corresponds to ./javelin/src/main/java/ca/ohri/javelin/data/model/schedule/Vaccine.kt
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("mad-utils/lib/shared");
var javelin_exports_1 = require("../javelin-exports");
/********************************* EXPORT DATA WITH TYPES APPLIED *********************************/
exports.Vaccine = javelin_exports_1.javelin.data.model.schedule.Vaccine;
shared_1.defineProp(exports.Vaccine.prototype, 'JVLN_CLASS_NAME', 'Vaccine', false);
//# sourceMappingURL=vaccine.js.map